// -*-mode: rjsx -*-
import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { lighten, makeStyles } from '@material-ui/core/styles';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
// eslint-disable-next-line
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
// eslint-disable-next-line
import Checkbox from '@material-ui/core/Checkbox';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import DeleteIcon from '@material-ui/icons/Delete';
import grey from "@material-ui/core/colors/grey"

// eslint-disable-next-line
//import * as _ from "lodash"


// LOGGING SETUP
import appConfig from "./../../../App.config.js"
// eslint-disable-next-line
const log = appConfig.getLogger("<DashInfo>")

const headCells = [
    { id: 'issue', numeric: false, disablePadding: true, label: 'Issue' },
    { id: 'allRank', numeric: true, disablePadding: false, label: 'Rank' },
    { id: 'counts-chart', numeric: false, chart: true, disablePadding: false, label: 'Feedback Count' },
];

function EnhancedTableHead(props) {
    const { classes,
            // eslint-disable-next-line            
            onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort } = props;
    const createSortHandler = property => event => {
        onRequestSort(event, property);
    };

    return (
        <TableHead>
          <TableRow style={{
                        backgroundColor: "#438CFF",
                    }}>
            <TableCell padding="checkbox">
              <div style={{
                  textAlign: "center",
                  color: "white",
                  fontSize: 19,
              }}>#</div>
              {/*
                 <Checkbox
                 indeterminate={numSelected > 0 && numSelected < rowCount}
                 checked={numSelected === rowCount}
                 onChange={onSelectAllClick}
                 inputProps={{ 'aria-label': 'select all desserts' }}
                 />
               */}
            </TableCell>
            {headCells.map(headCell => (
                <TableCell
                  key={headCell.id}
                  align={headCell.numeric ? 'right' : headCell.chart ? 'center' : 'left'}
                  padding={headCell.disablePadding ? 'none' : 'default'}
                  sortDirection={orderBy === headCell.id ? order : false}
                >
                  <TableSortLabel
                    active={orderBy === headCell.id}
                    direction={order}
                    onClick={createSortHandler(headCell.id)}
                    classes={{
                        root: classes.headLabelRoot,
                        icon: classes.headLabelIcon,
                    }}
                // style={{color: "grey"}}
                  >
                    {headCell.label}
                    {orderBy === headCell.id ? (
                        <span className={classes.visuallyHidden}>
                          {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                        </span>
                    ) : null}
                  </TableSortLabel>
                </TableCell>
            ))}
          </TableRow>
        </TableHead>
    );
}

EnhancedTableHead.propTypes = {
    classes: PropTypes.object.isRequired,
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
};

const useToolbarStyles = makeStyles(theme => ({
    root: {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(1)
    },


    rootHeader1Only: {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(1),
        minHeight: theme.spacing(4),
    },


    
    highlight:
    theme.palette.type === 'light'
        ? {
            color: theme.palette.secondary.main,
            backgroundColor: lighten(theme.palette.secondary.light, 0.85),
        }
    : {
        color: theme.palette.text.primary,
        backgroundColor: theme.palette.secondary.dark,
    },

    header1: {
        // flex: '1 1 100%',
        // backgroundColor: "grey"
        fontFamily: '"Segoe UI Historic", "Segoe UI", Helvetica, Arial, sans-serif',
        fontSize: "17px",
        fontWeight: "600",
    },

    header2: {
        // flex: '1 1 100%',
        // backgroundColor: "black"
        fontFamily: '"Segoe UI Historic", "Segoe UI", Helvetica, Arial, sans-serif',
        fontSize: "15px",
        color: "#65676b"
    },
    
}));


function EnhancedTableToolbar(props) {
    const classes = useToolbarStyles();
    const { header1, header2, numSelected } = props;

    return (
        <Toolbar
          className={clsx(classes.root, {
              [classes.rootHeader1Only]: !header2,
          })}
        >
          {numSelected > 0 ? (
              <Typography className={classes.title} color="inherit" variant="subtitle1">
                {numSelected} selected
              </Typography>
          ) : (
              <div className={classes.headersWrapper}>
                <Typography className={classes.header1} variant="h6" id="tableHeader1">
                  {header1}
                </Typography>
              { header2 &&
                <Typography className={classes.header2} variant="h6" id="tableHeader2">
                  {header2}
                </Typography>
              }
              </div>
          )}

          {numSelected > 0 ? (
              <Tooltip title="Delete">
                <IconButton aria-label="delete">
                  <DeleteIcon />
                </IconButton>
              </Tooltip>
          ) : (
              <Tooltip title="Filter list">
                <IconButton aria-label="filter list">
                  {/*
                  <FilterListIcon />
                   */}
                </IconButton>
              </Tooltip>
          )}
        </Toolbar>
    );
};

EnhancedTableToolbar.propTypes = {
    numSelected: PropTypes.number.isRequired,
};

const useStyles = makeStyles(theme => ({
    root: {
        width: '100%',
        height: '100%',
        // marginTop: theme.spacing(2),
    },
    paper: {
        width: '100%',
        height: '100%',
        marginBottom: theme.spacing(2),
    },
    table: {
        minWidth: 75,
    },
    tableWrapper: {
        overflowX: 'auto',
    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1,
    },

    headLabelRoot: {
        color: "white",
        fontSize: 19,

        // only this is working
        "&.MuiTableSortLabel-active": {
            color: theme.palette.common.white
        },

        '&:focus': {
            color: theme.palette.common.white
        },
        
        '&:hover': {
            color: grey[100],
            // fontSize: "15px", // stretches the whole thing
        },

        //        '& :active': {
        //            color: "white"
        //        }

    },

    headLabelIcon: {
        fontSize: 22,
        
        // this is possible, but does not work
        // '& svg': {
        //},
        
        '& path': {
            fill: theme.palette.common.white,
            // working, but don't need it
            //            '&:hover': {
            //                fill: red[100],
            //            },
        }
    },
    
    chartCell: {
        /*
        backgroundColor: "pink",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: 0,

        '&:hover': {
            backgroundColor: "rgba(0, 0, 0, 0.04)",
        },
        */
    },

    text1: {
        fontFamily: '"Segoe UI Semibold", "Segoe UI", Helvetica, Arial, sans-serif',
        fontSize: "17px",
        color: "#65676b"
    },
    
}));

export default function DashInfo(props) {

    const { dataset,
            header1, header2,
            text1,
            showHighlights,
            highlights
          } = props
    
    log.trace("DashInfo(): dataset =", dataset)
    log.trace("DashInfo(): showHighlights =", showHighlights)
    log.trace("DashInfo(): highlights =", highlights)
    
    const classes = useStyles()
    // const [order, setOrder] = React.useState('asc')
    // const [orderBy, setOrderBy] = React.useState('allRank')
    const [selected, setSelected] = React.useState([])
    // const [page, setPage] = React.useState(0)

    let rows

    if(dataset) {
        rows = dataset.map(d => {
            log.trace("map: setting up rows, d =",d)
            let issue
            if(d.issue && d.issue.txt) {
                issue = d.issue.txt
            } else {
                issue = "Loading..."
            }
            
            let allRank
            if(d.allRank) {
                allRank = d.allRank
            } else {
                allRank = "Loading..."
            }

            return {
                issue: issue,
                allRank: allRank,
            }
        })
            .reduce((rows, d) => { // make sure that we get 1 row per issue only
                log.trace("reduce: rows =",rows)
                log.trace("reduce: d =",d)
                if(!rows.find(row => row.issue === d.issue))
                    rows.push(d)
                return rows
            },[])
    }
    

    log.trace("body: rows =",rows)

    // config, this 5 is config
    // const [rowsPerPage, setRowsPerPage] = React.useState(12)

    // eslint-disable-next-line
    const handleClick = (event, issue) => {
        const selectedIndex = selected.indexOf(issue);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, issue);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }

        setSelected(newSelected);
    }

    /*
    // eslint-disable-next-line
    const handleChangePage = (event, newPage) => {
        setPage(newPage)
    }

    // eslint-disable-next-line
    const handleChangeRowsPerPage = event => {
        setRowsPerPage(parseInt(event.target.value, 10))
        setPage(0)
    }
    */

    /*
    const handleMouseOver = row => event => {
        log.trace("handleMouseOver(): row =",row)
        log.trace("handleMouseOver(): props =", props)
        // setCurrentIssue(row.issue)
        props.onRowHover(row) // call upper-level routine 
    }
    */

    /*
    const handleMouseOut = row => event => {
        // TODO: only do mouseout if we "really" left the issue
        // and are not staying on the same row
        //log.trace("handleMouseOut(): row =",row)
        //log.trace("handleMouseOut(): props =", props)
        //log.trace("handleMouseOut(): currentIssue =", currentIssue)
        //log.trace("handleMouseOut(): row.issue =", row.issue)
        props.onRowUnhover(row) // call upper-level routine 
    }
    */

    // const isSelected = issue => selected.indexOf(issue) !== -1;

    // const emptyRows = rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage);

    return (
        <div className={classes.root}>
          <Paper className={classes.paper}>
            <EnhancedTableToolbar
              header1={header1}
              header2={header2}
              text1={text1}
              numSelected={selected.length} />
            <div style={{
                padding: 0,
                paddingLeft: 20,
                paddingRight: 20,
                paddingBottom: 64 * 2 - 10, // TODO: 64 is the height of the header, not sure what the calc is here
                                            // we can work on that later
                height: "100%"}}>
                <Typography className={classes.text1} variant="h6" id="text1">
                  {text1}
                </Typography>
            </div>
          </Paper>
        </div>
    );
}
